<template>
  <master-main
    :addProperties="{
      eventType: 1,
      routeToCreate: getModuleRoute,
    }"
    :exportProperties="{
      pdf: {
        filename: `${$t('sigatoka.sigatoka_config')}_${dateToday}.pdf`,
        route: `${getModuleRoute}/pdf`,
      },
      xls: {
        filename: `${$t('sigatoka.sigatoka_config')}_${dateToday}.xlsx`,
        route: `${getModuleRoute}/excel`,
      },
    }"
    :dataBadges="[
      {
        columnLabel: $t('common_words.associated_companies2'),
        data: 'businesses',
        property: 'name',
        minWidth: 180,
      },
    ]"
    :route="getModuleRoute"
    :showProperties="showProperties"
    :tableProperties="tableProperties"
    @refresh="refresh"
    @showHideLoading="showHideLoading"
    @showNotification="notifyVue"
  >
  </master-main>
</template>
<script>
import { getDateToday } from 'src/util/Util';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMain from 'src/mixins/master/mixin-main';
import MixinRerender from 'src/mixins/mixin-rerender';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinWithDialog from 'src/mixins/master/mixin-with-dialog';
import MasterMain from 'src/components/Layouts/Masters/MasterMain.vue';
import ConfigTable from 'src/views/Pages/Dashboard/Sigatoka/Config/config-table';

export default {
  components: { MasterMain },
  data() {
    return {
      tableProperties: {},
      showProperties: { size: '70%' },
    };
  },
  mixins: [
    MixinMain,
    MixinAlert,
    MixinLoading,
    MixinRerender,
    MixinWithDialog,
    MixinPermissions,
  ],
  computed: {
    getModuleRoute() {
      return 'sigatoka/config';
    },
    dateToday() {
      return getDateToday();
    },
    buildTableProperties() {
      return {
        tableColumns: [...ConfigTable().tableColumns],
        model: 'sigatokaconfig',
        effectTags: 'dark',
        defaultSort: { prop: 'businesses', order: 'ascending' },
      };
    },
  },
};
</script>
